import { Link } from "react-router-dom";
import { TbArrowRight } from "react-icons/tb";

export const BaasHomeSnapshotSection = ({
  title,
  viewTo,
  viewLabel,
  /**
   * When true, parent owns the primary heading/link.
   * Still show a compact subsection label so peer columns share chrome height
   * and the inner cards stretch to the same size.
   */
  embedded = false,
  className = "",
  children,
}) => (
  <section className={`flex h-full min-w-0 w-full flex-col ${className}`.trim()}>
    {embedded && title ? (
      <p className="dashboard-section-label mb-3">{title}</p>
    ) : null}
    {!embedded && title ? (
      <div className="mb-3 flex flex-wrap items-center justify-between gap-2">
        <p className="dashboard-section-label">{title}</p>
        {viewTo ? (
          <Link
            to={viewTo}
            className="link-no-zoom inline-flex items-center gap-1 text-xs font-semibold text-[#e7a73f] transition hover:underline dark:text-brand-gold-mid"
          >
            {viewLabel}
            <TbArrowRight className="h-3.5 w-3.5" aria-hidden />
          </Link>
        ) : null}
      </div>
    ) : null}
    <div className="flex min-h-0 flex-1 flex-col">{children}</div>
  </section>
);
